import React from 'react'
import {
Box,
Button,
Grid,
Select,
Switch,
DeleteForeverIcon,
MenuItem ,
styled,
Paper,
Menu,
alpha,
useState,
GetCookie,
toast,
useCallback,
useLocation,
useEffect,
useAddMediatoAsOfflineMutation,
ScreenWisePostScheduling,
swal,
useMemo,
} from '../../Libraries/Post/GetAllPostRelatedToScreen/AllPosts/index';
import CircularProgressbar from '@mui/material/CircularProgress';
import ImageLazyLoading from '../../components/ImageLazyLoad/ImageLazyLoading';
import demoimg from '../../Assets/Images/DemoImageformedia.png'
import { IconButton } from "@mui/material";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import DeleteIcon from "@mui/icons-material/Delete";
import { red } from "@mui/material/colors";
import {
    useGetAllMediaOfCurrentScreenMutation, 
    useUpdatePostStatusInScreenMutation,
    useChangeMediaOrderMutation,
    useUpdateMediaDurationMutation,
    useDeleteMediaMutation,
    useCreatePostForSingleScreenMutation,
} from '../../Redux/service/AllEmpData';
import {Dialog, ChooseMedia} from '../../Libraries/Post/AddNewPost/Child/AddPostMiddleForm/index';
import plusIcon from "../../Assets/svgs/primary-shape.svg";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: "start",
  color: theme.palette.text.secondary,
  borderRadius: theme.spacing(0),
  boxShadow: "none",
}));
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

// export default function MediaContent({mediadata, currentScreen, loading}) {
export default function MediaContent({currentScreen}) {
    const [mediadata , setmediadata] = useState([]);
    
    const [getAllMediaOfCurrentScreenFromDB] =
        useGetAllMediaOfCurrentScreenMutation();
    const [loadingMedia, setLoadingMedia] = useState(false);
    const [selectedMedia, setSelectedMedia] = useState(null);
    const [createPostForSingleScreen] = useCreatePostForSingleScreenMutation();
    const [openAddpostDialog, setOpenAddPostDialog] = useState(false);
    const [deleteMedia] = useDeleteMediaMutation();
    const [data, setdata] = useState({
        playingpost: false,
        selectedpost: null,
        screenwisePostStatuscomponent: false,
      });
    const [updateMediaDuration] = useUpdateMediaDurationMutation();
    const [addMediatoAsOffline] = useAddMediatoAsOfflineMutation();
    const [ChangeOrder] = useChangeMediaOrderMutation();
    const [mediaList, setMediaList] = useState([]);
    const durationOptions = [
        { value: "30000", label: "30 seconds" },
        { value: "60000", label: "1 minute" },
        { value: "120000", label: "2 minute" },
        ];
    const [screenPostStatusChange, { isLoading: screenwisePostStatusloading }] =
        useUpdatePostStatusInScreenMutation();
    function sizeFormat (bytes) {
        const kb = 1024;
        const mb = kb * 1024;
        const gb = mb * 1024;
        const tb = gb * 1024;
    
        if (bytes >= 0 && bytes < kb) {
        return `${bytes}B`;
        } else if (bytes >= kb && bytes < mb) {
        return `${Math.ceil(bytes / kb)}KB`;
        } else if (bytes >= mb && bytes < gb) {
        return `${Math.ceil(bytes / mb)}MB`;
        } else if (bytes >= gb && bytes < tb) {
        return `${Math.ceil(bytes / gb)}GB`;
        } else if (bytes >= tb) {
        return `${Math.ceil(bytes / tb)}TB`;
        } else {
        return `${bytes}B`;
        }
    };

    const handleChangePostStatus = async (e, assocId) => {
        try {
            const mediaToUpdate = mediaList.find(
                item => Number(item.ser_assoc_id) === Number(assocId)
            );

            if (!mediaToUpdate) return;

            setMediaList(prev =>
                prev.map(item =>
                    Number(item.ser_assoc_id) === Number(assocId)
                        ? { ...item, post_status: e.target.checked }
                        : item
                )
            );
            const payload = new FormData();
            payload.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
            payload.append("security_token", await GetCookie("es_token"));
            payload.append("post_status", e.target.checked);
            payload.append("ser_assoc_id", mediaToUpdate.ser_assoc_id);

            const res = await screenPostStatusChange(payload).unwrap();

            if (res.connection === "true" && res.status === "true") {
                toast.success(res.message);
            } else {
                toast.info(res.message);
                setMediaList(prev =>
                    prev.map(item =>
                        Number(item.ser_assoc_id) === Number(assocId)
                            ? { ...item, post_status: !e.target.checked }
                            : item
                    )
                );
            }
        } catch (error) {
            console.error(error);
            toast.error(error.status);
            setMediaList(prev =>
                prev.map(item =>
                    Number(item.ser_assoc_id) === Number(assocId)
                        ? { ...item, post_status: !item.post_status }
                        : item
                )
            );
        }
    };


    const handlePreviewClick = async (index) => {
        console.log("Testing");
    }
    const handleMediaAsOffline = async (media) => {
        try {
                const payload = new FormData();

                payload.append(
                "txt_customer_id",
                localStorage.getItem("txt_customer_id")
                );
                payload.append("security_token", await GetCookie("es_token"));
                payload.append("ser_media_id", media.finalfile.ser_media_id);
                payload.append("ser_assoc_id", media.ser_assoc_id);
                payload.append("ser_screen_id", media.ser_screen_id);
                payload.append(
                "txt_media_offline_status",
                media.is_offline_available === "true" ? "false" : "true"
                );

                const res = await addMediatoAsOffline(payload).unwrap();

                if (res.connection === "true" && res.status === "true") {
                toast.success(res.message);
                setMediaList(prev =>
                    prev.map(item =>
                    item.ser_assoc_id === media.ser_assoc_id
                        ? {
                            ...item,
                            is_offline_available:
                            item.is_offline_available === "true" ? "false" : "true",
                        }
                        : item
                    )
                );
                } else {
                toast.error(res.message);
                }
            } catch (error) {
                console.error(error);
                toast.error(error.status);
        }
    };

    const handleNewOrder = useCallback(
        async (option, assocId) => {
            if (!option?.value) return;

            const newOrder = option.value;

            const formObj = new FormData();
            formObj.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
            formObj.append("security_token", await GetCookie("es_token"));
            formObj.append("ser_assoc_id", assocId);
            formObj.append("ser_screen_id", currentScreen.ser_screen_id);
            formObj.append("txt_order_no", newOrder);

            try {
            const returned = await ChangeOrder(formObj).unwrap();

            if (returned.connection === "true" && returned.status === "true") {
                toast.success(returned.message);

                setMediaList(prev => {
                const updated = prev.map(item =>
                    item.ser_assoc_id === assocId
                    ? { ...item, order_no: newOrder }
                    : item
                );
                getMedia();

                return [...updated].sort(
                    (a, b) => Number(a.order_no) - Number(b.order_no)
                );
                
                });
            } else {
                toast.error(returned.message);
            }
            } catch (error) {
            console.error(error);
            toast.error(error.status);
            }
        },
        [ChangeOrder, currentScreen]
        );

    const handleDurationChange = async (e, index) => {
        try {
          let mediaToUpdate = "";
          if (Number.isInteger(index) && index >= 0 && index < mediaList.length
          ) {
              mediaToUpdate = mediaList[index];
              console.log(mediaToUpdate);
          }
          const payload = new FormData();
          payload.append(
            "txt_customer_id",
            localStorage.getItem("txt_customer_id")
          );
          payload.append("security_token", await GetCookie("es_token"));
          payload.append("image_post_duration", e.value);
          payload.append("ser_assoc_id", mediaToUpdate.ser_assoc_id);
    
          const res = await updateMediaDuration(payload).unwrap();
          if (
            res.connection === "true" &&
            res.status === "true" &&
            res.message === "Timer updated successfully"
          ) {
            toast.success(res.message);
            getMedia();
          } else if (res.connection === "true" && res.status === "false") {
            toast.info(res.message);
          } else {
            toast.error(res.message);
          }
        } catch (error) {
            console.error(error);
            toast.error(error.status);
            }
      };
      const handleSchduleModal = (media) => {
            setdata(prev => ({
            ...prev,
            selectedpost: media,
            screenwisePostStatuscomponent: true,
            }));
        };

         const handleSchduleModalClose = () => {
            setdata({
            ...data,
            selectedpost: null,
            screenwisePostStatuscomponent: false,
            });
        };

          const handleDeleteMedia = async (e, index) => {
            let mediaToUpdate = "";
            if (Number.isInteger(index) && index >= 0 && index < mediaList.length
              ) {
                  mediaToUpdate = mediaList[index];
              }
            swal({
              title: "Remove Media!",
              text: "Are you sure you want to remove the media from this screen?",
              icon: "warning",
              buttons: true,
              dangerMode: true,
            }).then(async (willUnLink) => {
              if (willUnLink) {
                try {
                  const data = new FormData();
                  data.append(
                    "txt_customer_id",
                    localStorage.getItem("txt_customer_id")
                  );
                  data.append("security_token", await GetCookie("es_token"));
                  data.append("ser_assoc_id", mediaToUpdate.ser_assoc_id);
        
                  const res = await deleteMedia(data).unwrap();
                  if (
                    res.status === "true" &&
                    res.message === "Media deleted successfully" &&
                    res.connection === "true"
                  ) {
                    toast.success(res.message);
                    getMedia();
                  } else {
                    toast.error(res.message);
                  }
                } catch (error) {
                  console.log(error);
                  toast.error(error.status);
                }
              }
            });
        };
        
        
    const addnewpost = () => {
        setOpenAddPostDialog(true);
    };
    const mediaselectionfooter = (
        <React.Fragment>
          <Button
            variant="contained"
            className="mt-3 capitalized fs-14 fw-bold"
            onClick={hideDialogAndCreatePost}
          >
            Submit
          </Button>
        </React.Fragment>
      );

     async function hideDialogAndCreatePost() {
        if (!selectedMedia) {
            toast.error("Please select a media first");
            return;
        }

        const createPostFormData = new FormData();
        createPostFormData.append(
            "txt_customer_id",
            localStorage.getItem("txt_customer_id")
        );
        createPostFormData.append("security_token", await GetCookie("es_token"));
        createPostFormData.append("post_type", selectedMedia.type);
        createPostFormData.append("txt_post_status", "true");
        createPostFormData.append("ser_media_id", selectedMedia.ser_media_id);
        createPostFormData.append("ser_screen_id", currentScreen.ser_screen_id);
        createPostFormData.append(
            "image_post_duration",
            selectedMedia.type === "Image" ? "30000" : "N/A"
        );

        CreatePost(createPostFormData);
        }

        const CreatePost = async (createPostdata) => {
            try {
                const response = await createPostForSingleScreen(createPostdata).unwrap();
                if (
                response.message === "Post saved successfully" &&
                response.connection === "true" &&
                response.status === "true"
                ) {
                hideDialog();
                toast.success(response.message);
                getMedia();
        
                } else {
                toast.error(response.message);
                }
            } catch (error) {
                console.error(error);
                toast.error(error.error);
            }
        };
         const hideDialog = () => {
            setOpenAddPostDialog(false);
            getMedia();
        };
       const handleChangefinalfile = (value) => {
            setSelectedMedia(value);
            };
        const getMedia = async () => {
            setLoadingMedia(true);
            try {
                const formData = new FormData();
                formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
                formData.append("security_token", await GetCookie("es_token"));
                formData.append("ser_screen_id", currentScreen.ser_screen_id);
                
                const res = await getAllMediaOfCurrentScreenFromDB(formData).unwrap();
                if (res.status === "true") {
                    setmediadata(res);
                // dispatch(setMedia(res));
                } else {
                    setmediadata([]);
                // toast.error(res.message);
                }
            } catch (error) {
                toast.error("Failed to fetch media");
            } finally {
                setLoadingMedia(false);
            }
        };
    useEffect(() => {
    if (Array.isArray(mediadata?.data)) {
        setMediaList(mediadata.data);
    } else {
        setMediaList([]);
    }
    }, [mediadata]);

    const options = useMemo(() => {
    if (!mediaList || mediaList.length === 0) return [];
    
    return mediaList.map((_, i) => ({
        value: i + 1,
        label: String(i + 1),
    }));
    }, [mediaList.length]);
    useEffect(() => {
        if (currentScreen?.ser_screen_id) {
            getMedia();
        }
        }, [currentScreen?.ser_screen_id]);

  return (
    <>
                    <Box sx={{ flexGrow: 1}}>
                    <Grid
                        container
                        spacing={0}
                        className="flex align-items-center bg bg-white py-3 px-4"
                        sx={{ borderRadius: '16px'}}
                    >
                        <div className="row justify-content-between no-gutters ml-1 mr-1">
                            <div className="col col-sm-6 col-md-6 col-lg-6 ">
                            <h5 style={{ color: "grey" }}>
                                <b>Media</b>
                            </h5>
                            </div>
                        </div>
                        {loadingMedia ? (
                            <Box
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    minHeight: "200px", 
                                }}
                            >
                                <div style={{ width: 80, height: 80 }}>
                                    <CircularProgressbar />
                                </div>
                            </Box>
                        ) : (
                            <table className="table align-middle bg-white" >
                            <thead className="bg-light fs-14" >
                                <tr>
                                <th
                                    style={{
                                    backgroundColor: "#1A75E8",
                                    color: "white",
                                    alignItems: "center",
                                    textAlign: "center",
                                    }}
                                >
                                    Preview
                                </th>
                                <th
                                    style={{
                                    backgroundColor: "#1A75E8",
                                    color: "white",
                                    alignItems: "center",
                                    textAlign: "center",
                                    }}
                                >
                                    File Size
                                </th>
                                <th
                                    style={{
                                    backgroundColor: "#1A75E8",
                                    color: "white",
                                    alignItems: "center",
                                    textAlign: "center",
                                    }}
                                >
                                    Sequence
                                </th>
                                <th
                                    style={{
                                    backgroundColor: "#1A75E8",
                                    color: "white",
                                    alignItems: "center",
                                    textAlign: "center",
                                    }}
                                >
                                    Display
                                </th>
                                <th
                                    style={{
                                    backgroundColor: "#1A75E8",
                                    color: "white",
                                    alignItems: "center",
                                    textAlign: "center",
                                    }}
                                >
                                    Offline
                                </th>
                                <th
                                    style={{
                                    backgroundColor: "#1A75E8",
                                    color: "white",
                                    alignItems: "center",
                                    textAlign: "center",
                                    }}
                                >
                                    Duration
                                </th>

                                <th
                                    style={{
                                    backgroundColor: "#1A75E8",
                                    color: "white",
                                    alignItems: "center",
                                    textAlign: "center",
                                    }}
                                >
                                    Schedule
                                </th>
                                <th
                                    style={{
                                    backgroundColor: "#1A75E8",
                                    color: "white",
                                    alignItems: "center",
                                    textAlign: "center",
                                    }}
                                >
                                    Delete
                                </th>
                                </tr>
                            </thead>

                            <tbody>
                        {Array.isArray(mediaList) && mediaList.length > 0 ? (
                            mediaList.map((currentRow, index) => (
                                <tr key={currentRow.ser_assoc_id}>
                                <td>
                                    <div
                                        onClick={() => {
                                        handlePreviewClick(index);
                                        }}
                                    >
                                        <ImageLazyLoading
                                        src={
                                            currentRow.finalfile
                                            .txt_media_file_type === "Video"
                                            ? currentRow.base64_media_thumbnail
                                            : currentRow.finalfile
                                                .txt_media_streaming_link
                                        }
                                        alt={"img"}
                                        width={"105px"}
                                        height={"65px"}
                                        style={{
                                            borderRadius: "8px",
                                            border: "3px solid #F0F0F0",
                                        }}
                                        />
                                    </div>
                                </td>
                                 <td
                                    style={{
                                    width: "15%",
                                    alignItems: "center",
                                    textAlign: "center",
                                    wordBreak:"break-word"
                                    }}
                                >
                                    <h6 style={{fontSize:'14px'}}>{sizeFormat(currentRow.media_size)}</h6>
                                </td>
                                <td
                                    style={{
                                    width: "20%",
                                    alignItems: "center",
                                    textAlign: "center",
                                    }}
                                >
                                <Select
                                    styles={{fontSize: '14px'}}
                                    options={options}
                                    value={options.find(opt => opt.value === currentRow.order_no)}
                                    onChange={(option) => handleNewOrder(option, currentRow.ser_assoc_id)}
                                    isClearable
                                    placeholder={String(currentRow.order_no)}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    />
                                </td>
                                 <td
                                    style={{
                                    width: "15%",
                                    alignItems: "center",
                                    textAlign: "center",
                                    }}
                                >
                                    <Switch
                                    key={currentRow.ser_assoc_id}
                                    checked={currentRow.post_status}
                                    inputProps={{ "aria-label": "controlled" }}
                                    onChange={(e) => {
                                        handleChangePostStatus(e, currentRow.ser_assoc_id);
                                    }}
                                    />
                                </td>
                                <td>
                                    <Switch
                                    checked={currentRow.is_offline_available === 'true'}
                                    inputProps={{ "aria-label": "controlled" }}
                                    onChange={(e) => {
                                        handleMediaAsOffline(currentRow);
                                    }}
                                    />
                                </td>
                                <td
                                    style={{
                                    width: "20%",
                                    alignItems: "center",
                                    textAlign: "center",
                                    }}
                                >
                                    <Select
                                    isDisabled={
                                        currentRow.finalfile
                                        .txt_media_file_type === "Image"
                                        ? false
                                        : true
                                    }
                                    options={durationOptions}
                                    value={durationOptions.find(
                                        (option) =>
                                        option.value ===
                                        currentRow.image_post_duration
                                    )}
                                    onChange={(e) => {
                                        handleDurationChange(e, index);
                                    }}
                                    isClearable={true}
                                    placeholder={currentRow.image_post_duration}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    />
                                </td>
                                <td
                                    style={{
                                    width: "20%",
                                    alignItems: "center",
                                    textAlign: "center",
                                    }}
                                >
                                     <IconButton>
                                        <AccessTimeFilledIcon
                                        onClick={() =>
                                            handleSchduleModal(currentRow)
                                        }
                                        color={
                                            currentRow.is_scheduled == true
                                            ? "primary"
                                            : "action"
                                        }
                                        />
                                    </IconButton>
                                </td>
                                 <td
                                    style={{
                                        width: "20%",
                                        alignItems: "center",
                                        textAlign: "center",
                                    }}
                                    >
                                    <IconButton>
                                        <DeleteIcon
                                        onClick={(e) => handleDeleteMedia(e, index)}
                                        sx={{ color: red[900] }}
                                        />
                                    </IconButton>
                                </td>
                                </tr>
                            )) ) : (
                                <tr>
                                <td
                                    colSpan="8"
                                    style={{
                                    textAlign: "center",
                                    padding: "30px",
                                    fontWeight: "600",
                                    color: "#888",
                                    }}
                                >
                                    No Media Found
                                </td>
                                </tr>
                                )}
                            </tbody>

                            </table>
                             )}
                            <Box className="flex justify-content-center" sx={{width: '100%'}}>
                                 <Button 
                                 startIcon={
                                        <img
                                        src={plusIcon}
                                        alt="plus"
                                        className="plus-icon"
                                        style={{
                                            width: "18px",
                                            height: "18px",
                                            objectFit: "contain",
                                            transition: "0.3s ease",
                                        }}
                                        />
                                    }
                                 variant="contained" 
                                 sx={{
                                    maxHeight: "48px",
                                    height: "40px",
                                    width: "250px",
                                    fontWeight: "bold",
                                    textTransform: "none",
                                    borderRadius: "8px",
                                    background: "#1A75E829",
                                    boxShadow: "none",
                                    color: "#1A75E8",
                                    fontSize: "15px",
                                    transition: "0.3s ease",
                                    marginTop:"10px",
                                    marginBottom:"10px",

                                    "&:hover": {
                                    backgroundColor: "#1A75E8",
                                    color: "#ffffff",
                                    boxShadow: "none",
                                    },

                                    "&:hover .plus-icon": {
                                    filter: "brightness(0) invert(1)",
                                    },
                                }}
                                 onClick={addnewpost}
                                 >
                                    Add Media
                                </Button>
                            </Box>
                        
                        
                    </Grid>
                    </Box>
                    <Dialog
                        visible={openAddpostDialog}
                        style={{ width: "1200px", height: "600px" }}
                        breakpoints={{ "960px": "75vw", "640px": "100vw" }}
                        header={"Select Media"}
                        modal
                        maximizable={true}
                        footer={mediaselectionfooter}
                        onHide={hideDialog}
                    >
                        <ChooseMedia
                        setfinalfile={handleChangefinalfile}
                        finalfile={selectedMedia}
                        />
                    </Dialog>

                    <StyledMenu
                    id="demo-customized-menu"
                    MenuListProps={{
                        "aria-labelledby": "demo-customized-button",
                    }}
                    >
                        <MenuItem
                        disableRipple
                        >
                        <DeleteForeverIcon />
                        Delete Post
                        </MenuItem>
                    </StyledMenu>
                    {data.screenwisePostStatuscomponent === true ? (
                            <ScreenWisePostScheduling
                              show={data?.screenwisePostStatuscomponent}
                              close={handleSchduleModalClose}
                              screen={currentScreen.ser_screen_id}
                              schinfo={data?.selectedpost}
                              currentScreen={currentScreen}
                              refreshMedia={getMedia}
                            />
                          ) : null}
                </>

  )
}
